import { __ } from '@wordpress/i18n';

// @ts-ignore
const { Spinner } = window.wc.blocksComponents;
const CardListLoader = () => {
    return(
        <div className='dokan-mangopay-registered-cards-loader'>
            <Spinner/>
            <span className='dokan-mangopay-registered-cards-loader-label'>{__( 'Processing...', 'dokan' )}</span>
        </div>
    );
}

export default CardListLoader;
